import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// store modules
import auth from "./modules/auth";
import faqs from "./modules/faqs";
import snackbar from "./modules/snackbar";
import types from "./modules/types";
import ui from "./modules/ui";

const development = process.env.NODE_ENV === "development";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    faqs,
    snackbar,
    types,
    ui
  },
  strict: development,
  plugins: [createPersistedState()]
});

store.dispatch("snackbar/reset", null, { root: true });
store.dispatch("types/clearConnections", null, { root: true });
store.dispatch("faqs/clearConnections", null, { root: true });

export default store;
